<div class="user-container">
    <span class="user-small-icon"></span>
    <span class="user-name ml8">{{name}}</span>
    <span class="user-date ml6" *ngIf="date">{{date | formDate}}</span>
</div>

<ng-content></ng-content>
